export default __webpack_public_path__ + "static/media/back.7ead4ae8.svg";